var map = {
	"./Biermann2019.jpg": "e657",
	"./Doll2020.jpg": "14dd",
	"./Hofmann2019.jpg": "5754",
	"./Huster2022.jpg": "ec49",
	"./Jarosch2021.jpg": "8af0",
	"./Jimenez2022.jpg": "37f9",
	"./Kaehler2019.jpg": "688b",
	"./Klimpel-Hildebrandt2019.jpg": "50b6",
	"./Koehler2020.jpg": "954d",
	"./Kretschmer2022.jpg": "70c3",
	"./Lauffs2019.jpg": "ff95",
	"./Streckert2019.jpg": "91b0",
	"./Tobola2019.jpg": "f2c7",
	"./Zwingelberg2022.jpg": "50d6",
	"./placeholder3.jpg": "056f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "09f3";